import Vue from 'vue';
import '@/plugins/vue-currency-filter';
import '@/plugins/moment';

export const bus = new Vue();
